import { PASSWORD_REGEX } from '@/utils/regex.utils';
import i18next from 'i18next';
import { z } from 'zod';

export const resetPasswordSchema = z
  .object({
    password: z.string().superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('common:passwordRequired'),
        });
      } else if (!PASSWORD_REGEX.test(data)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('common:passwordFormatIncorrect'),
        });
      }
    }),
    passwordConfirm: z.string().superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('common:passwordConfirmRequired'),
        });
      }
    }),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.passwordConfirm) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['passwordConfirm'],
        message: i18next.t('common:passwordConfirmIncorrect'),
      });
    }
  });

export type TResetPassword = z.infer<typeof resetPasswordSchema>;
